const HTTP_CONSTANTS = {
    SESSION_TIMEOUT: 401,
    SESSION_ROLE_ADMIN : 'datahub_admin',
    SESSION_ROLE_PARTICIPANT : 'datahub_participant'
};  

export default HTTP_CONSTANTS;